import { initializeNeuroGuide, logger } from '@ignitesales/neuro-application';
import BranchThemeApp from "../../../../../_themes/centralOnlineTheme/src/main/js/BranchThemeApp.jsx"
import LoadingAppComponent from "../../../../../_themes/centralOnlineTheme/src/main/js/LoadingAppComponent.jsx"
import messages from '../i18n/messages.mjs';
import { getParametersValue } from '../../../../../_themes/centralOnlineTheme/src/main/js/utils/getParams.js';
import customMessages from "../i18n/custom";

const referenceParameter = getParametersValue();

const onCentralStateInit = async (neuroState) => {
  return {
    ...neuroState,
    bankSelected: referenceParameter.bank,
    marketSelected: referenceParameter.market
  }
}

const init = async () => {

  await initializeNeuroGuide ({
    AppComponent: BranchThemeApp,
    AppLoadingComponent: LoadingAppComponent,
    messages: messages,
    onStateInit: onCentralStateInit,
    guideConfig: {
      customMessages: customMessages,
      urlParamAnswers: {
        bank: referenceParameter.bank,
        market: referenceParameter.market,
      }
    }
  });

  logger.info('Go for takeoff!');
};

init();
